export const newId = (key?: string) =>
  `${key ? key : ""}${Math.round(Math.random() * 10 * new Date().valueOf())}`;
